import {flatMap, map, mergeMap} from 'rxjs/operators';
import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AppService} from '../../commons/app.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatSidenav, MatSnackBar} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import {Dataset, FourDService, Project, Transform, TransformGroup, TransformType} from '4d-mapper';
import {MainComponent} from '../main.component';
import {MainService} from '../main.service';
import {forkJoin, of as observableOf} from 'rxjs';
import {AppBaseComponent} from '../../commons/AppBaseComponent';
import {MapService} from '../../commons/map.service';
import {Constants} from '../../commons/Constants';
import {EntityHelperService} from '../../service/entity-helper.service';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';
import { AclService } from '../../commons/acl/acl.service';
import { QuickGuidesComponent } from '../map/quick-guides/quick-guides.component';
import { CoordHelperService } from '@src/app/service/coord-helper.service';
import { XsAwait } from '@src/app/xs/controllers/await.class';
import { UiManagerService } from '@src/app/xs/services/ui/ui-manager.service';
import { TicketRequest } from '@src/app/commons/models';


// declare var fdm: any;
const Cesium = (<any>window).Cesium;

@Component({
  selector: 'projs-comp',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss',
    '../map/map.component.scss']
})
export class ProjectsListComponent extends AppBaseComponent implements OnInit, OnDestroy {
    
  debug:boolean = Constants.debug_off;

  projects: Project[] = [];
  filteredProjects: Project[] = [];
  favouriteProjects: Project[] = [];
  
  project_selected = null;
  project_selected_obj = null;

  quickguides: QuickGuidesComponent
  // We need to use a setter here as the component is inside an ngIf directive
  @ViewChild('quickguides', {static: false}) set content(content: QuickGuidesComponent) {
    if(content) { // initially setter gets called with undefined
        this.quickguides = content;
    }
  }

  @ViewChild('sidenav', {static: true}) sidenav: MatSidenav;



  showHangOn = Constants.showHangOn;
  private project_banner = [];
  private project_area = null;
  private project_scratch = null;
  private project_info = null;

  private TYPE_THUMB: TransformType;

  private overloadClicks: Function;
  // private viewer: any;
  private handler: any
  // private scene: any
  private dataSource = new Cesium.CustomDataSource('myData');
  private hiddenProjectId: Array<number> = new Array<number>();
  NAME = 'GENERIC.SORT_NAME';
  LAST_USED = 'GENERIC.SORT_USED';
  sortBy = [this.LAST_USED, this.NAME];
  currentSortBy = this.LAST_USED;

  // our Cesium map viewer (where all the 3D action is)
  cesiumMapViewer:any = null;

  // states
  allowRotateGlobe:boolean = false;
  doRotateGlobe:boolean = false;
  doShowTipsLarge:boolean = false;

  // rotation
  rotationSpinRate:number = 0.027;
  rotationActualRate:number = 0;
  rotateTimestamp:any = null;

  // bit of a hack to get Component types through
  //isType:string = 'ProjectsListComponent';
  
  constructor(public fourD: FourDService, public service: AppService, private r: Router, sn: MatSnackBar, d: MatDialog, private ar: ActivatedRoute,
    private t: TranslateService, private mainComponent: MainComponent, private mainService: MainService, public uiManager: UiManagerService, public mapService: MapService, public coordHelper: CoordHelperService,
    public entityHelper:EntityHelperService, private trans: TranslateService, applicationEvents:XsApplicationEventsService, public permissions: AclService ) {

    super(service, r, sn, d, applicationEvents);

    if (!localStorage.getItem('currentSortBy')) {
      this.saveCurrentSortBy();
    } else {
      this.currentSortBy = localStorage.getItem('currentSortBy');
    }
  }

  initAfter() {

    if ( this.debug ) { console.log ( 'projects :: init()' ) ;}

    this.readyFoudD();
    this.mainService.newProjectCreatedSubject.subscribe(project => {
      this.projects.push(project);
      this.copyProjectsInFilteredProjects();
    })
  }

  destroy() {
    if ( this.debug ) { console.log ( 'projects :: destroy()' ) ;}
  }

  ___mapViewerDestroyStart (obj:any = null ) {
    if ( this.debug ) { console.log ( '%c projects.component %c ___mapViewerDestroyStart ------------------------------------------ ', this.debugPrimary, this.debugSecondary, obj ); }
    this.cesiumMapViewer = null;
  }

  // listen out for when the mapViewer / CesiumMap is ready (ref; XsEventListenerInterface)
  ___mapViewer (obj:any = null ) {

    this.cesiumMapViewer = obj.viewer;

    // wait until the viewer is filled with goodies ...
    XsAwait.until(['cesiumMapViewer.scene', 'cesiumMapViewer.dataSources', 'cesiumMapViewer.canvas'], this ).then ( _ => {
      this.mapViewerFinal();
    });
  }

  distanceToZero:any = null;
  distanceCartographic:any = null;
  cartesianSurface:any = null;

  mapViewerFinal() {

    if ( this.debug ) { console.log ( '%c projects.component %c ___mapViewer ------------------------------------------ ', this.debugPrimary, this.debugSecondary, this.cesiumMapViewer ); }

    this.cesiumMapViewer.dataSources.add(this.dataSource);
    this.handler = new Cesium.ScreenSpaceEventHandler(this.cesiumMapViewer.canvas);
    this.handler.setInputAction((movement) => this.clickedPoint(movement), Cesium.ScreenSpaceEventType.LEFT_CLICK);

    this.initAfter();
  
    this.project_info = document.getElementById('project_info');

    this.cesiumMapViewer.scene.preRender.addEventListener((info) => {

      // nab the cartographic coords of the camera position
      this.distanceCartographic = this.cesiumMapViewer.camera.positionCartographic;

      // calculate a cartesian coord of where the camera is looking, to the surface of the globe
      this.cartesianSurface = new Cesium.Cartesian3.fromRadians(this.distanceCartographic.longitude,this.distanceCartographic.latitude, 0);

      // calculate the distance between the camera and that surface point
      this.distanceToZero = Cesium.Cartesian3.distance ( this.cesiumMapViewer.camera.position, this.cartesianSurface );
      
      if ( this.project_info ) {
        if (this.project_area && this.project_area.position ) {

          var canvasPosition = this.cesiumMapViewer.scene.cartesianToCanvasCoordinates(this.project_area.position._value);
  
          if (Cesium.defined(canvasPosition)) {
            this.project_info.style.top = canvasPosition.y + 'px';
            this.project_info.style.left = canvasPosition.x + 'px';
          }
  
        } else {
          this.project_info.style.top = '-500px';
          this.project_info.style.left = '-500px';
        }
      }

    });

    this.cesiumMapViewer.clock.onTick.addEventListener( (clock) => {
      this.rotateGlobe();
    });
      
  }

  rotateGlobe() {
    if ( !this.allowRotateGlobe ) {
      return;
    }

    const now = Date.now();
    let delta = (now - this.rotateTimestamp ) / 1000;
    this.rotateTimestamp = now;

    // spin positive
    if ( this.doRotateGlobe ) {
      if ( this.rotationActualRate < this.rotationSpinRate ) {
        this.rotationActualRate = this.rotationActualRate + 0.0008;
      }
    } else {
      if ( this.rotationActualRate > 0 ) {
        this.rotationActualRate = this.rotationActualRate - 0.0008;
      }
    }
    
    this.cesiumMapViewer.scene.camera.rotate(Cesium.Cartesian3.UNIT_Z, this.rotationActualRate * delta);
  }

  startRotateGlobe() {
    this.rotateTimestamp = Date.now();
    this.doRotateGlobe = true;
  }

  stopRotateGlobe() {
    this.doRotateGlobe = false;
  }

  saveActiveTeam() {
    let me = this;
    setTimeout ( ()=>{
      me.fourD.activeTeam.saveObservable().subscribe();
      me.showTips();
      me.quickguides.updateGuide();
    }, 500);
  }

  // callback from quick guides
  closeQuickGuides() {
    this.showTips();
    this.fourD.activeTeam['showQuickGuides'] = false;
    this.saveActiveTeam();
  }

  openQuickGuides() {
    this.uiManager.toggleQuickGuidePopup("dashboard",true)
    this.fourD.activeTeam['showQuickGuides'] = true;
    this.saveActiveTeam();
  }

  actionQuickGuides ( action:string, data:any = null ) {
    //console.log('######### projects :: actionQuickGuides() callback', action, data );
    switch (action) {

      case 'saas':
        this.fourD.activeTeam['showProjectTips'] = false;
        this.fourD.activeTeam.saveObservable().subscribe();
        this.showTips();
        this.quickguides.updateType();
        break;

      case 'contact_us':
        if ( data ) {
          this.sendMessage(data);
        }
        break;
    }
  }
  
  sendMessage ( form:any ) {

    //console.log('######### projects :: sendMessage()', this.quickguides );
    this.quickguides.setState('sending');

    const request:TicketRequest = {
      priority:'normal',
      category:'question',
      body: form.MESSAGE.value
    };

    this.service.sendSupportTicket(request).subscribe(
      res => {
        this.quickguides.setState('sent');
        //console.log('!! email OK', request, res );
      },e => {
        this.quickguides.setState('sent_error');
        //console.log('!! email ERROR', request, e );
      }
    );

  }


  showTips() {

    // console.log('!! 1');
    
    if ( this.fourD && this.fourD.activeTeam ) {
      // console.log('!! 2');
      if ( this.fourD.activeTeam.hasOwnProperty('showProjectTips') ) {


        // reset
        // this.fourD.activeTeam['showProjectTips'] = true;

        // console.log('!! 3', this.fourD.activeTeam['showProjectTips'] );

      } else {
        // console.log('!! 4');
        this.fourD.activeTeam['showProjectTips'] = true;
      }

      this.doShowTipsLarge = this.fourD.activeTeam['showProjectTips'];
      if ( this.doShowTipsLarge ) {
        this.uiManager.toggleQuickGuidePopup("dashboard",true)
      }

      // should we open it?
      if ( this.fourD.activeTeam['showProjectTips'] ) {
        if ( this.sidenav.opened ) {
          this.sidenav.toggle();
        }
        /*
        let dialogRef = this.dialog.open(ProjectTipsDialogComponent, {
          width: '30%',
          data: {}
        });
        dialogRef.afterClosed().subscribe(v => {
          console.log('!! 5', this.fourD.activeTeam['showProjectTips'] );
        });
        */
      } else {
        if ( !this.sidenav.opened ) {
          this.sidenav.toggle();
        }
      }


    }
  }






  private readyFoudD() {
    
    if ( this.debug ) { console.log ( 'projects :: readyFoudD()' ) ; }

    this._subs.push(this.fourD.onSocketCommand("create_project").subscribe(s => 
      this.refreshProjects()
    ))
    this.fourD.onActiveAccountReady().subscribe(_ => {
      
      this.fourD.activeTeam['showProjectTips'] = false;
      if ( this.fourD.activeTeam['showQuickGuides'] ) {
        this.uiManager.toggleQuickGuidePopup("dashboard",true)
      }
      this.refreshProjects();

      //console.log('-- Account --', this.fourD.activeTeam, this.fourD.activeUser, this.projects );

      this.TYPE_THUMB = this.fourD.transformTypes.find(t => t.uid == 'thumb')
      this.ar.params.subscribe(s => {
        if (s.projId) {
          this.editProject(this.projects.find(p => p.id === parseInt(s.projId)));
        }
      });
    });
  }

  private refreshProjects(){
    this.loading = true;
    this.fourD.V.searchByObject(Project).useCache(true).equals('active',true).limit(1000).queryObservable().subscribe(t => {

      this.projects = t.items
      this.fourD.projects = t.items
      if ( this.debug ) { console.log ( 'projects :: readyFoudD() :: onActiveAccountReady()', this.fourD.projects ) ;}

      if ( this.mapService && this.mapService.viewer ) {
        this.cesiumMapViewer = this.mapService.viewer;
      }

      // if we haven't shown any tips, now's the time!
      this.showTips();

      this.copyProjectsInFilteredProjects();
      this.loadProjects();
      this.loading = false;
    })
  }
  
  invite(project: Project) {
    this.trans.get('SIGNIN.EMAIL').subscribe(email => {
      var v = {placeholder: email}

      this.openDialog('SHARES.ADD', 'SHARES.ADD_INST', 'SHARES.INVITE', 'GENERIC.CANCEL', v).subscribe(s =>
        this.fourD.V.api('/share/' + project.id, 'post', {email: s}).subscribe(s => {
          this.trans.get('SHARES.INVITED', {email: s}).subscribe(ss =>
            this.openSnackBarInfo(ss)
          )
        }, e => this.openSnackBarError(e.message))
      )
    })
  }

  projectGoto() {
    const e = document.getElementById('project_info_load');
    if (e) {
      e.click();
    }
  }


  getCoordsForProject ( p: any ) {
    const c = this.coordHelper.getCoordsFromItem(p);
    return { llng: c.longitude, llat: c.latitude };

    /*
    if (  p['firstTransformCoords'] ) {
      coords = p['firstTransformCoords'];
      // console.log ( 'coords firstTransformCoords', coords );
    }

    else if ( p.props['cameraPosition'] ) {

      if ( p.props['cameraPosition']['position'] ) {
        const carto  = Cesium.Ellipsoid.WGS84.cartesianToCartographic( p.props['cameraPosition']['position'] );
        if ( carto && carto['longitude'] ) {
          coords['llng'] = Cesium.Math.toDegrees(carto.longitude);
          coords['llat'] = Cesium.Math.toDegrees(carto.latitude);
        }
      }


      // console.log ( 'coords cameraPosition', coords, carto, p.props['cameraPosition']['position'] );
    }

    else if ( p.llng && p.llat ) {
      coords['llng'] = p.llng;
      coords['llat'] = p.llat;

      // console.log ( 'coords inline', coords );
    }

    else {
      // console.log ( 'coords none' );
    }

    return coords;
*/
  }

  height_min:number =  5000000;
  height_max:number = 14000000;

  mouseSelect(project: any = null ) {

    

    /*
    if (!project['firstTransformCoords']) { // if no position set then dont open the popup
      this.router.navigate(['map', project.id], {relativeTo: this.ar});
      return;
    }
    */

    // is there already a project entity?
    if (this.project_area !== null) {
      // remove it
      this.cesiumMapViewer.entities.remove(this.project_area);
      this.project_area = null;
    }


    if ( !project ) {
      if ( this.project_selected_obj && this.cesiumMapViewer ) {
        let coords = this.getCoordsForProject ( this.project_selected_obj );
        if ( coords['llng'] ) {
          this.cesiumMapViewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(coords['llng'], coords['llat'], this.height_max),
            maximumHeight: this.height_max,
            duration: 1
          });
        }
      }
      this.project_selected = null;
      this.project_selected_obj = null;
      this.startRotateGlobe();
      return;
    }

    
    this.project_selected = project.id;
    this.project_selected_obj = project;

    if ( project.props['isNew'] ) {
      project.props['isNew'] = false;
      project.saveObservable().subscribe();
    }

    var color = Cesium.Color.RED;

    

    let coords = this.getCoordsForProject ( project );

    console.log('#project', this.project_selected_obj, coords );

    if ( coords['llng'] ) {

      this.stopRotateGlobe();

      this.project_area = this.cesiumMapViewer.entities.add({
        name:'selected project marker',
        position: Cesium.Cartesian3.fromDegrees( coords['llng'], coords['llat'], 200),
        point: {
          pixelSize: 25,
          color: color,
          outlineColor: Cesium.Color.WHITE,
          outlineWidth: 3,
          // heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
          disableDepthTestDistance:Number.POSITIVE_INFINITY
        }
        /* label : {
                text : project.name,
                fillColor : color,
                showBackground: true,
                scale: 0.7,
                verticalOrigin : Cesium.VerticalOrigin.CENTER,
                horizontalOrigin : Cesium.HorizontalOrigin.LEFT
            }*/

        /*billboard : {
                image : pinBuilder.fromColor(Cesium.Color.ROYALBLUE, 58).toDataURL(),
                verticalOrigin : Cesium.VerticalOrigin.BOTTOM
            } */
      });

      this.cesiumMapViewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(coords['llng'], coords['llat'], this.height_min),
        maximumHeight: this.height_min,
        duration: 1
      });

    } else {
      // this.projectGoto();
    }

  }

  toggleProjectFavourite( p:Project) {
    if ( !p.props.hasOwnProperty('favourite') ) {
      p.props['favourite'] = true;
    } else {
      p.props['favourite'] = ! p.props['favourite'];
    }
    p.saveObservable().subscribe();
    if ( this.debug ) { console.log ( 'projects :: toggleProjectFavourite()', p, p.props ) ;}
    this.copyProjectsInFilteredProjects();
  }

  private copyProjectsInFilteredProjects() {
    if ( this.debug ) { console.log ( 'projects :: copyProjectsInFilteredProjects()' ) ;}
    this.filteredProjects = Object.assign([], this.projects);
    this.sortProject();
    this.favouriteProjects.length = 0;
    this.filteredProjects.forEach(p => {
      if ( p.props && p.props.favourite ) {
        this.favouriteProjects.push(p);
      }
    });
  }



  deleteProject(p: Project) {

    var okMSg, errMsg;

    this.translate.get(['PROJECT.DELETE.SUCCESS', 'PROJECT.DELETE.ERROR']).pipe(map(params => {
      okMSg = params['PROJECT.DELETE.SUCCESS']
      errMsg = params['PROJECT.DELETE.ERROR']
    }), mergeMap(e => {
      return this.openDialogWithMeta({name: p.name}, 'PROJECT.DELETE.TITLE', 'PROJECT.DELETE.MSG', 'GENERIC.YES', 'GENERIC.NO').pipe(
        flatMap(s => {
          if (s) {

            return p.destroyObservable().pipe(map(_ => true))
          }
          else {
            return observableOf(null)
          }
        })
      )
    }),).subscribe(
      s => {
        if (s) {
          this.openSnackBarInfo(okMSg, null)
          this.projects = this.projects.filter(pp => pp.id !== p.id)
          this.fourD.projects = this.projects
          this.copyProjectsInFilteredProjects();
        }
      },
      e => this.openSnackBarError(errMsg, null, {msg: e.message})
    );


  }

  addNew() {

    var p = {value: ''};
    this.openDialog('PROJECTS.NEW', null, null, null, p).subscribe(res => {
      if (res) {
        var p = new Project(this.fourD.V)
        p.name = res
        p.account = this.fourD.activeTeam
        p['ignoreOrientation'] = true;
        p.saveObservable().subscribe(
          s => {
            s.fetchObservable().subscribe(v => {
              this.projects.push(v);
              this.copyProjectsInFilteredProjects();
              this.router.navigate(['map', p.id], {relativeTo: this.ar})
            });
          },
          e => {
            if (e.status == 92001)
              this.openDialog('PLAN.QUOTA', 'PLAN.QUOTA_DESC_PROJ')
            else
              this.openSnackBarError(e.message, null)
          }
        );
      }
    });
  }

  editProject(p: Project) {
    this.translate.get('PROJECTS.NAME').subscribe(value => {
      var inp = {
        value: p.name,
        placeholder: value
      };
      p['saved'] = false;

      this.openDialogWithModeAndFilterAndMeta({project: p}, 'file', 'Dataset', 'PROJECTS.DIALOG.EDIT_DETAILS', '', 'GENERIC.SAVE', 'DIALOG.DELETE', inp).subscribe(dest => {
          if (dest && dest.selectedFiles && dest.selectedFiles.length) {
            this.saveProjectDetails(dest);

            this.fourD.V.searchByObject(TransformGroup).equals('project', p).equals('name', MapService.DEFAULT_GROUP)
              .queryObservable().subscribe(value1 => {
              if (value1.items.length > 0) {
                this.addPhotosAndTransformINTransformgGroup(dest, p, value1.items[0]);
              } else {
                let tg = new TransformGroup(this.fourD.V);
                tg.set({
                  name: MapService.DEFAULT_GROUP,
                  project: p
                });
                tg.saveObservable().subscribe(value1 => {
                  this.addPhotosAndTransformINTransformgGroup(dest, p, tg);
                });
              }

            });

            /*var queryString = ''
            dest.selectedFiles.filter(d => d['canPlot']).forEach(d => queryString += '|' + d['canPlot'])
            queryString = queryString.substring(1);
            let alreadyExist = false;
            if (queryString.length > 0) {
              /!*this.fourD.V.searchByObject(Transform)*!/
              p.transforms.equals('id', queryString)
                .queryObservable()
                /!*.pipe(
                flatMap(res =>
                  forkJoin(res.items.map(t => {

                      /!*transform.forEach(value => {
                        if(value.id === t.id){
                          alreadyExist = true;
                          return;
                        }
                      });
                      if (!alreadyExist) {
                        return p.transforms.addObserveable(t);
                      }*!/

                     return p.transforms.queryObservable();

                    })
                  )
                )
              )*!/.subscribe(
                s => {
                  /!*s.forEach(res => {
                    if(res.items.id === t.id){
                      alreadyExist = true;
                      return;
                    }
                  });
                  if (!alreadyExist) {
                    p.transforms.addObserveable(t).subscribe();
                  }
                });*!/
                  if (s.items.length > 0) {
                    this.openSnackBarError('Data already exists', null);
                  } else {
                    this.fourD.V.searchByObject(TransformGroup).equals('project', p).equals('name', MapService.DEFAULT_GROUP)
                      .queryObservable().subscribe(value1 => {
                      if (value1.items.length > 0) {
                        this.addChildrenInTG(queryString, p, value1.items[0]);
                      } else {
                        let tg = new TransformGroup(this.fourD.V);
                        tg.set({
                          name: MapService.DEFAULT_GROUP,
                          project: p
                        });
                        tg.saveObservable().subscribe(value1 => {
                          this.addChildrenInTG(queryString, p, tg);
                        });
                      }

                    });


                  }

                  // this.copyProjectsInFilteredProjects();
                  // this.r.navigateByUrl('/app/projects');
                }
                ,
                e => {
                  if (alreadyExist) {
                    this.openSnackBarError('Data already exists', null)
                  } else {
                    this.openSnackBarError(e.message, null)
                  }
                  // this.copyProjectsInFilteredProjects();
                  // this.r.navigateByUrl('/app/projects');
                }
              )
            }*/


            /*var queryString1 = ''
            dest.selectedFiles.filter(d =>  d.dataType.uid === 'photo').forEach(d => queryString += '|' + d['canPlot'])
            queryString = queryString.substring(1);
            let alreadyExist = false;
            if (queryString.length > 0) {
              /!*this.fourD.V.searchByObject(Transform)*!/
              p.transforms.equals('id', queryString)
                .queryObservable()
                /!*.pipe(
                flatMap(res =>
                  forkJoin(res.items.map(t => {

                      /!*transform.forEach(value => {
                        if(value.id === t.id){
                          alreadyExist = true;
                          return;
                        }
                      });
                      if (!alreadyExist) {
                        return p.transforms.addObserveable(t);
                      }*!/

                     return p.transforms.queryObservable();

                    })
                  )
                )
              )*!/.subscribe(
                s => {
                  /!*s.forEach(res => {
                    if(res.items.id === t.id){
                      alreadyExist = true;
                      return;
                    }
                  });
                  if (!alreadyExist) {
                    p.transforms.addObserveable(t).subscribe();
                  }
                });*!/
                  if (s.items.length > 0) {
                    this.openSnackBarError('Data already exists', null);
                  } else {
                    this.fourD.V.searchByObject(TransformGroup).equals('project', p).equals('name', MapService.DEFAULT_GROUP)
                      .queryObservable().subscribe(value1 => {
                      if (value1.items.length > 0) {
                        this.addChildrenInTG(queryString, p, value1.items[0]);
                      } else {
                        let tg = new TransformGroup(this.fourD.V);
                        tg.set({
                          name: MapService.DEFAULT_GROUP,
                          project: p
                        });
                        tg.saveObservable().subscribe(value1 => {
                          this.addChildrenInTG(queryString, p, tg);
                        });
                      }

                    });


                  }

                  // this.copyProjectsInFilteredProjects();
                  // this.r.navigateByUrl('/app/projects');
                }
                ,
                e => {
                  if (alreadyExist) {
                    this.openSnackBarError('Data already exists', null)
                  } else {
                    this.openSnackBarError(e.message, null)
                  }
                  // this.copyProjectsInFilteredProjects();
                  // this.r.navigateByUrl('/app/projects');
                }
              )
            }*/

            /*else {
                         this.copyProjectsInFilteredProjects();
                         this.r.navigateByUrl('/app/projects');
                       }*/
          } else if (dest && dest.project && !dest.selectedFiles && dest.project['nuked'] === true) {
            this.projects = this.projects.filter(pp => pp.id !== p.id)
            this.fourD.projects = this.projects;
            this.openSnackBarSuccess('GENERIC.DELETED');
          } else if (dest && dest.project && !dest.selectedFiles && dest.project['nuked'] === 'Error') {
            this.openSnackBarError('PROJECT.DELETE_ERROR');
          } else if (dest && dest.project && !dest.selectedFiles) {
            this.saveProjectDetails(dest);
          }
          this.copyProjectsInFilteredProjects();
        },
        e => this.openSnackBarError(e.message, null)
      )
    });


    /*let dialogRef = this.dialog.open(ProjectEditorComponent, {
      width: '80%',
      restoreFocus: false,
      data: {project: p}
    });

    dialogRef.afterClosed().subscribe(p => {
      if (p && p.nuked) {
        this.projects = this.projects.filter(pp => pp.id !== p.id)
        this.fourD.projects = this.projects
      }
      else if (p && !this.projects.find(pp => pp.id === p.id)) {
        this.projects.push(p)
      }else if (p && this.projects.find(pp => pp.id === p.id)) {
        this.projects[this.projects.findIndex(pp => pp.id === p.id)] = p;
      }
      this.copyProjectsInFilteredProjects();
      this.r.navigateByUrl('/app/projects')
    });*/

  }

  private addPhotosAndTransformINTransformgGroup(dest, p: Project, tg: TransformGroup) {
    var ds: Dataset[] = dest.selectedFiles
    var toAdd: number[] = []
    ds.filter(d => d['canPlot']).forEach(d => d.transformIds.forEach(tid => toAdd.push(tid)))
    forkJoin(toAdd.map(t => {
        let toAddTransform = new Transform(this.fourD.V).set({id: t});
        p.transforms.addObserveable(toAddTransform).subscribe();
        this.fourD.V.searchByObject(Transform).equals('id', t).queryObservable().subscribe(value => {
          if (value.items[0].transformType.uid == 'three-d-tiles' && !value.items[0].pointCloudShading) {
            value.items[0].pointCloudShading = {
              'geometricErrorScale': 1,
              'attenuation': true,
              'maximumAttenuation': 8,
              'baseResolution': 0,
              'eyeDomeLighting': false,
              'eyeDomeLightingStrength': 1,
              'eyeDomeLightingRadius': 1
            }
            value.items[0].saveObservable().subscribe();
          }
        });

        if (!tg['layerProps']) {
          tg['layerProps'] = [];
        }
        // p.props[MapService.TOGGLE + tg.id + '_' + t] = true;
        // p.props[MapService.ALPHA + tg.id + '_' + t] = 1;
        tg['layerProps'][MapService.TOGGLE + t] = true;
        tg['layerProps'][MapService.ALPHA + t] = 1;
        tg.saveObservable().subscribe();
        return tg.children.addObserveable(toAddTransform);
      }
    )).subscribe(_ => {
    });
    if (dest.selectedFolder) {
      tg.addImagesFromFolder(dest.selectedFolder).subscribe();
    }
    /* toAdd = []
     ds.filter(d => d.dataType.uid === 'photo').forEach(d => d.transformIds.forEach(tid => toAdd.push(tid)));
     forkJoin(toAdd.map(t => {
         let toAddTransform = new Transform(this.fourD.V).set({id: t});
         return tg.photos.addObserveable(toAddTransform);
       }
     )).subscribe(_ => {
     });*/
  }

  private addChildrenInTG(queryString: string, p: Project, tg: TransformGroup) {
    this.fourD.V.searchByObject(Transform).equals('id', queryString).queryObservable().subscribe(
      value1 => {
        value1.items.forEach(t => {
          // p.props[MapService.TOGGLE + tg.id + '_' + t.id] = true;
          // p.props[MapService.ALPHA + tg.id  + '_' + t.id] = 1;
          // p.saveObservable().subscribe();
          p.transforms.addObserveable(t).subscribe();
          tg.children.addObserveable(t).subscribe();
        });
        this.openSnackBarSuccess('GENERIC.FILE_SAVED', null);
      }
    );
  }

  private saveProjectDetails(dest) {
    if (dest.project && dest.project['saved'] === true) {
      this.openSnackBarSuccess('GENERIC.PROJECT_SAVED');
      if (dest.project && !this.projects.find(pp => pp.id === dest.project.id)) {
        this.projects.push(dest.project);
        this.sortProject();
      } else if (dest.project && this.projects.find(pp => pp.id === dest.project.id)) {
        this.projects[this.projects.findIndex(pp => pp.id === dest.project.id)] = dest.project;
        this.sortProject();
      }
    } else if (dest.project && dest.project['saved'] === 'Error') {
      this.openSnackBarError('PROJECT.SAVE_ERROR');
    } else if (dest.project) {
      if (dest.project && !this.projects.find(pp => pp.id === dest.project.id)) {
        (dest.project);
        this.sortProject();
      } else if (dest.project && this.projects.find(pp => pp.id === dest.project.id)) {
        this.projects[this.projects.findIndex(pp => pp.id === dest.project.id)] = dest.project;
        this.sortProject();
      }
    }
  }

  loadProjects() {

    let me = this;

    this.service.V.pathPrefix = '/app/Account/' + this.fourD.activeTeam.id + '/api';

    this.projects.forEach(p => {
      if (p) {
        var pid = p.id;

        let shouldUpdate = false;
        let found = [];

        if ( p['imageFileDatas'] ) {
          shouldUpdate = true;
          p['imageFileDatas'] = null;
          found.push('imageFileDatas');
        }

        if ( p['cameraPosition'] && p['cameraPosition']['frustum'] ) {
          shouldUpdate = true;
          p['cameraPosition']['frustum'] = null;
          found.push('cameraPosition.frustum');
        }

        if ( p['props'] && p['props']['cameraPosition'] && p['props']['cameraPosition']['frustum'] ) {
          shouldUpdate = true;
          p['props']['cameraPosition']['frustum'] = null;
          found.push('props.cameraPosition.frustum');
        }

        if ( shouldUpdate ) {
          try {
            p.saveObservable().subscribe( yay => {
              // console.log ( 'project ['+pid+'] updated / cleaned', p, found );
            }, boo => {
              // console.log ( 'project ['+pid+'] updated / cleaned ERROR', p, found, boo );
            });
          } catch (error) {
            console.log ( 'project ['+pid+'] updated / cleaned BIG ERROR', p, found, error );
          }
        } else {
          // console.log ( 'project ['+pid+'] no cleaning', p, found );
        }


        // if ( this.debug ) { console.log ( 'projects :: loadProjects() p=', p ) ;}
        if (this.cesiumMapViewer && this.cesiumMapViewer.entities) {

          let coords = this.getCoordsForProject ( p );

          if ( coords['llng'] ) {

            // console.log ( 'coords found, drawing' );

            let p = Cesium.Cartesian3.fromDegrees(coords['llng'], coords['llat'], 100);

            this.project_banner[pid] = this.cesiumMapViewer.entities.add({
              name:'project marker',
              id: pid,
              position: p,
              point: {
                pixelSize: 20,
                color: Cesium.Color.BLUE,
                outlineColor: Cesium.Color.WHITE,
                outlineWidth: 3,
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                disableDepthTestDistance: new Cesium.CallbackProperty( () => {
                  let d:number = Math.round ( (p && me.cartesianSurface) ? Cesium.Cartesian3.distance ( me.cartesianSurface, p ) : 0 );
                  if ( d > 7400000 ) {
                    return 50000;
                  } else {
                    return Number.POSITIVE_INFINITY;
                  }
                }),
                // translucencyByDistance : new Cesium.NearFarScalar(this.height_min, 1.0, 0, 0.0),
              },
              /* label: {
                font : '12px sans-serif',
                text: new Cesium.CallbackProperty( () => {
                  let d:number = Math.round ( (p && me.cartesianSurface) ? Cesium.Cartesian3.distance ( me.cartesianSurface, p ) : 0 );
                  // let r:number = Math.round(d - this.distanceToZero);
                  return 'd='+ d;
                }, false),
                showBackground: true,
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
                pixelOffset: new Cesium.Cartesian2(-12, -12),
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                horizontalOrigin: Cesium.VerticalOrigin.RIGHT,
                eyeOffset: new Cesium.Cartesian3(0, 0, -50),
              } */
            });

            /*
            if ( p['_coords'] ) {
              console.log ( 'PLOT COORDS ('+p.id+')', p['__coords'] );
              Object.keys(  p['_coords'] ).forEach ( scenekey => {
                let scene = p['_coords'][scenekey];
                console.log ( 'PLOT SCENE ('+p.id+','+scenekey+')', scene );
                if ( scene ) {
                  Object.keys(  scene ).forEach ( itemkey => {
                    if ( itemkey == 'default' ) {
                      console.log ( 'PLOT ('+p.id+','+scenekey+') SCENE', scene['default'] );
                      this.cesiumMapViewer.entities.add({
                        name:'scene marker',
                        position: scene['default'],
                        point: {
                          pixelSize: 60,
                          color: Cesium.Color.YELLOW,
                          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
                        }
                      });
                    } else {
                      if ( scene[itemkey]['longitude'] && scene[itemkey]['latitude'] ) {
                        console.log ( 'PLOT ('+p.id+','+scenekey+') ITEM', scenekey, itemkey, scene[itemkey] );
                        this.cesiumMapViewer.entities.add({
                          name:'item marker',
                          position: Cesium.Cartesian3.fromDegrees( scene[itemkey]['longitude'], scene[itemkey]['latitude'], 100 ),
                          point: {
                            pixelSize: 15,
                            color: Cesium.Color.WHITE,
                            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
                          }
                        });
                      }
                    }
                  });
                  
                }
              });
            }
            */

            this.project_banner[pid].addProperty('fdmid', pid);
          }

        }
      }
    });

    Constants.hideHangOn();

    if (this.cesiumMapViewer && this.cesiumMapViewer.entities) {

      // set up event listener for dealing with clicking on project billboards
      this.cesiumMapViewer.selectedEntityChanged.addEventListener((ent) => {

        if ( ent ) {

          // the listener grabs the id, finds an element with the project id, and clicks it to select
          var el = document.getElementById('project-' + ent._id).click();

        }


        // TODO: add a scrollTo for the project list, if it's out of view

      });
    }

    // this.setupCameras();

  }

  mouseEnter(item: any) {
    // console.log("mouse enter : " + div);
    // mapService.helper.sendCameraTo(cur)
    // this.flyTo(item)
  }

  mouseLeave(div : string){
    if ( this.debug ) { console.log('mouse leave :' + div);}
  }


  clickedPoint(movement: any) {
    if (this.overloadClicks) {
      this.overloadClicks(movement)
      return;
    }
    var feature = this.cesiumMapViewer.scene.pick(movement.position);
    var def = Cesium.defined(feature)
    if (def && !feature.content && feature.id.fourd_ref) {
      this.router.navigate(['map', feature.id.fourd_ref], {relativeTo: this.ar});
    }
  }

  setupCameras() {

    if ( this.debug ) { console.log ( 'projects :: setupCameras()' ) ;}

    if (this.cesiumMapViewer) {

      
    }
  }

  filterProjects(value: any) {

	if ( this.debug ) { console.log ( 'projects :: filterProjects()' ) ;}

    this.hiddenProjectId = new Array<number>();
    if (value) {
      this.filteredProjects = Object.assign([], this.projects).filter(
        project => {
          if (project.name !== null) {
            if (project.name.toLowerCase().search(value.toLowerCase()) !== -1) {
              return true;
            }
          }
        }
      );
    } else {
      this.copyProjectsInFilteredProjects();
    }
  }

  renameProject ( item:Project ) {

    const me = item.name;
    this.openDialog('PROJECTS.RENAME', null, 'GENERIC.SAVE', 'GENERIC.CANCEL', me).subscribe(res => {
      if (res) {
        item.name = res;
        item.saveObservable().subscribe();
      }
    });
  }

  sortProject() {
    if ( this.debug ) { console.log ( 'projects :: sortProject()' ) ;}
    this.filteredProjects = this.filteredProjects.sort((a, b) => {
      if (this.currentSortBy === this.NAME) {
        return a.name.localeCompare(b.name);
      }
      if (this.currentSortBy === this.LAST_USED) {
        return new Date(b['dateUpdated']).getTime() - new Date(a['dateUpdated']).getTime();
      }
    });
  }

  saveCurrentSortBy() {
    localStorage.setItem('currentSortBy', this.currentSortBy);
  }


}

